/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource, MatBottomSheet, MatDialog } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IceexpansionpanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,  ChartTypes,
  SECTION_CONTROL_ALIGNMENT,
  IceResponsiveMattableEditSettings
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { ReportService } from 'projects/icemedx-lib/src/services/report/report.service';
import { ScheduleService } from 'projects/icemedx-lib/src/services/schedule/schedule.service';
import { MedicalcodesService } from 'projects/icemedx-lib/src/services/medicalcodes/medicalcodes.service';

import { Command_Type, report, Report_Layout_Type, Report_Mode_Type } from '../../../../icemedx-lib/src/models/reports/report';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { ReportComponent } from '../report/report.component';
import { reportdata } from 'projects/icemedx-lib/src/models/reports/reportdata';
import { antenatalattendancestat } from 'projects/icemedx-lib/src/models/stats/antenatalattendancestat';
import { labordeliverystat } from 'projects/icemedx-lib/src/models/stats/labordeliverystat';
import { IcebottomSheetComponent } from 'projects/icemedx-lib/src/components/icebottomsheet/icebottomsheet.component';
import { patientstat } from 'projects/icemedx-lib/src/models/stats/patientstat';
import { accountingsummary } from '../../../../icemedx-lib/src/models/stats/accountingsummary';
import { SignerService } from '../../../../icemedx-lib/src/login/signer.service';
import { reviewer } from '../../../../icemedx-lib/src/models/ehr/subs/reviewer';
import { lodgemembershipsummary } from '../../../../icemedx-lib/src/models/stats/lodgemembshipsummary';
import { incomerevenuejournal } from '../../../../icemedx-lib/src/models/accounting/incomerevenuejournal';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { IMultimediaData } from '../../../../icemedx-lib/src/components/icemultimedia/IMultimediaData';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { reporttemplate } from '../../../../icemedx-lib/src/models/reports/reporttemplate';
import { clinicaldaysheetstat } from '../../../../icemedx-lib/src/models/stats/clinicaldaysheetstat';
import { assetjournal } from '../../../../icemedx-lib/src/models/accounting/assetjournal';
import { schedulereport } from '../../../../icemedx-lib/src/models/reports/types/schedulereport';
import { CustomFormService } from '../../../../icemedx-lib/src/services/custom/customform.service';

@Component({
  selector: 'viewreport',
  templateUrl: './viewreport.component.html',
  styleUrls: ['./viewreport.component.scss'],
  providers: [IceNavService, AppService]
})
export class ViewreportComponent extends ReportComponent implements OnInit {
  // data members
  reportData: reportdata = null;
  ancAttendanceData: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  laborDeliveryData: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  deliveryByAgeData: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  accountingSummaryData: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  lodgeMembershipData: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  revenueSummaryData: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  patientData: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  subTypeCodes: any[] = [];
  signedByData: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  // member settings
  whiteLabelHeader: string = "";
  ancAttendanceTable: IcemattableSettings = null;
  laborDeliveryTable: IcemattableSettings = null;
  deliveryByAgeTable: IcemattableSettings = null;
  patientTable: IcemattableSettings = null;
  attendanceChart: IcecontrolSettings = null;
  deliverySeriesChart: IcecontrolSettings = null;
  birthrateSeriesChart: IcecontrolSettings = null;
  accountingSummaryTable: IcemattableSettings = null;
  accountingSummaryChart: IcecontrolSettings = null;
  lodgeMembershipSummaryTable: IcemattableSettings = null;
  revenueSummaryTable: IcemattableSettings = null;

  signedByTable: IcemattableSettings = null;
  signButton: IcecontrolSettings = null;
  signTitle: IcecontrolSettings = null;
  signatureCtrl: IcecontrolSettings = null;
  readonlySignatureCtrl: IcecontrolSettings = null;

  // sample member settings
  samplePanelSettings: IcepanelSettings[] = [];

  constructor(appSvc: AppService,
    navSvc: IceNavService,
    loginSvc: LoginService,
    router: Router,
    activatedRoute: ActivatedRoute,
    rptService: ReportService,
    frmService: CustomFormService,
    schService: ScheduleService,
    private signerSvc: SignerService,
    codeSvc: MedicalcodesService,
    domainSvc: DomainService,
    changeDetectorRefs: ChangeDetectorRef, dialog: MatDialog, private bottomSheet: MatBottomSheet) {

    super(appSvc, navSvc, loginSvc, router, activatedRoute, rptService, frmService, schService, codeSvc, domainSvc, changeDetectorRefs, dialog);
    this.setReportMode(Report_Mode_Type.modePreview);
  }

  ngOnInit() {
    if (this.panelSync == null)
      this.getAppService().refreshMenus();

    if (this.panelSync != null) {
      this.panelSync.createInitializeEvent().subscribe(
        event => {
          debugger;
          super.loadReport({ key: this.reportKey });
        },
        error => {
        }
      );
    }
  }

  isAntenatalData(): boolean {
    return this.ancAttendanceData.data != null && this.ancAttendanceData.data.length > 0;
  }

  isLaborandDeliveryData(): boolean {
    return this.laborDeliveryData.data != null && this.laborDeliveryData.data.length > 0;
  }

  setupAntenatal(src: MatTableDataSource<any>): IcemattableSettings {
    let ret: IcemattableSettings = null;
    try {
      ret = new IcemattableSettings("ANCAttendanceTable", [
        new iceColumnDefinition("name", "ANTENATAL AND POSTNATAL STATS", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("value", "Results", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("table", "", false, true),
        new iceColumnDefinition("key", "", true, true),
      ],
        src,
        null,
        true,
        null,
        true);
    }
    catch (e) {

    }
    return ret;
  }

  setLaborandDelivery(src: MatTableDataSource<any>): IcemattableSettings {
    let ret: IcemattableSettings = null;
    try {
      ret = new IcemattableSettings("LaboarDeliveryTable", [
        new iceColumnDefinition("name", "LABOR AND DELIVERY STATS", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("value", "Results", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("table", "", false, true),
        new iceColumnDefinition("key", "", true, true),
      ],
        src,
        null,
        true,
        null,
        true);
    }
    catch (e) {
    }
    return ret;
  }

  setLaborandDeliveryByAge(src: MatTableDataSource<any>): IcemattableSettings {
    let ret: IcemattableSettings = null;
    try {
      ret = new IcemattableSettings("LaboarDeliveryByAgeTable", [
        new iceColumnDefinition("name", "DELIVERY BY AGE STATS", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("value", "All", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("male", "Male births", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("female", "Female births", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("multiple", "Multiple births", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("malestillbirth", "Male stillbirths", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("femalestillbirth", "Female stillbirths", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("maternaldeath", "Maternal deaths", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("table", "", false, true),
        new iceColumnDefinition("key", "", true, true),
      ],
        src,
        null,
        true,
        null,
        true);
    }
    catch (e) {
    }
    return ret;
  }

  setupAccountingSummary(src: MatTableDataSource<any>): IcemattableSettings {
    let ret: IcemattableSettings = null;
    try {
      ret = new IcemattableSettings("AccountingSummaryTable", [
        new iceColumnDefinition("name", "ACCOUNTING SUMMARY", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("value", "Results", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("table", "", false, true),
        new iceColumnDefinition("key", "", true, true),
      ],
        src,
        null,
        true,
        null,
        true);
    }
    catch (e) {

    }
    return ret;
  }

  setupLodgeMembershipSummary(src: MatTableDataSource<any>): IcemattableSettings {
    let ret: IcemattableSettings = null;
    try {
      ret = new IcemattableSettings("LodgeMembershipSummaryTable", [
        new iceColumnDefinition("name", "MEMBERSHIP SUMMARY", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("value", "", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("table", "", false, true),
        new iceColumnDefinition("key", "", true, true),
      ],
        src,
        null,
        true,
        null,
        true);
    }
    catch (e) {

    }
    return ret;
  }

  setupRevenueSummaryTable(src: MatTableDataSource<any>): IcemattableSettings {
    let ret: IcemattableSettings = null;
    try {
      ret = new IcemattableSettings("RevenueSummaryTable", [
        new iceColumnDefinition("name", "REVENUE SUMMARY", false, false,
          new IcecontrolSettings("icelabel", { width: "30%"}, null, null)),
        new iceColumnDefinition("value", "", false, false,
          new IcecontrolSettings("icelabel", { width: "70%" }, null, null)),
        new iceColumnDefinition("table", "", false, true),
        new iceColumnDefinition("key", "", true, true),
      ],
        src,
        null,
        true,
        null,
        true);
    }
    catch (e) {

    }
    return ret;
  }

  setupPatients(src: MatTableDataSource<any>): IcemattableSettings {
    let ret: IcemattableSettings = null;
    try {
      ret = new IcemattableSettings("PatientTable", [
        new iceColumnDefinition("name", "PATIENT DEMOGRAPHICS", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("codes", "All", false, false,
          new IcecontrolSettings("icelabel", {}, null, null)),
        new iceColumnDefinition("table", "", false, true),
        new iceColumnDefinition("key", "", true, true),
      ],
        src,
        null,
        true,
        null,
        true).setShowTable(false);
    }
    catch (e) {
    }
    return ret;
  }

  setupDaySheet(dtText: string, src: MatTableDataSource<any>): IcemattableSettings {
    let ret: IcemattableSettings = null;
    try {
      ret = new IcemattableSettings(dtText, [
        new iceColumnDefinition("index", "NO.", false, false),
        new iceColumnDefinition("name", "PATIENT", false, false),
        new iceColumnDefinition("appointment_count", "APPOINTMENTS", false, false),
        new iceColumnDefinition("encounter_count", "ENCOUNTERS", false, false),
        new iceColumnDefinition("encounter_signed_count", "SIGNED", false, false),
        new iceColumnDefinition("patient_consent_count", "CONSENTS", false, false),
        new iceColumnDefinition("service_count", "SERVICES", false, false),
        new iceColumnDefinition("diagnosis_count", "ICDs", false, false),
        new iceColumnDefinition("encounter_complete_count", "COMPLETE", false, false),
        new iceColumnDefinition("revenue_total", "TOTAL", false, false),
        new iceColumnDefinition("collected_total", "COLLECTED", false, false),
        new iceColumnDefinition("payer_count", "PAYERS", false, false),
        new iceColumnDefinition("eligibility_check_count", "ELIG. CHK", false, false),
        new iceColumnDefinition("claim_ready_count", "CLAIMS READY", false, false),
        new iceColumnDefinition("claim_clean_count", "CLEAN", false, false),
        new iceColumnDefinition("claim_sent_count", "SENT", false, false),
        new iceColumnDefinition("trans_account", "", true, true),
      ],
        src,
        null,
        true,
        null,
        true);
    }
    catch (e) {

    }
    return ret;
  }
  getAntenatalData(attndObj: antenatalattendancestat): any[] {
    if (attndObj == null) return [];

    let attndDisplay = [];
    try {

      let table = "ANTENATAL_ATTENDANCE_STAT";
      attndDisplay.push({ name: "Antenatal first visit before 14 weeks", value: attndObj.antenatal_first_visit_before_14weeks, table: table, key: "antenatal_first_visit_before_14weeks" });
      attndDisplay.push({ name: "Antenatal first visit before 20 weeks", value: attndObj.antenatal_first_visit_before_20weeks, table: table, key: "antenatal_first_visit_before_20weeks" });
      attndDisplay.push({ name: "Antenatal first visit 20 weeks or later", value: attndObj.antenatal_first_20_weeks_or_later, table: table, key: "antenatal_first_20_weeks_or_later" });
      attndDisplay.push({ name: "Antenatal first visit 28 weeks or later", value: attndObj.antenatal_first_28_weeks_or_later, table: table, key: "antenatal_first_28_weeks_or_later" });
      attndDisplay.push({ name: "Antenatal first visit Total", value: attndObj.antenatal_first_visit_total, table: table, key: "antenatal_first_visit_total" });
      attndDisplay.push({ name: "Antenatal visit Total", value: attndObj.antenatal_total, table: table, key: "antenatal_total" });
      attndDisplay.push({ name: "Positive for syphilis/VDRL", value: attndObj.anc_syphilis_positive, table: table, key: "anc_syphilis_positive" });
      attndDisplay.push({ name: "Total tested for syphilis/VDRL", value: attndObj.anc_syphilis_test, table: table, key: "anc_syphilis_test" });
      attndDisplay.push({ name: "Total who received malaria IPTi 1st dose", value: attndObj.received_malaria_ipt1, table: table, key: "received_malaria_ipt1" });
      attndDisplay.push({ name: "Total who received malaria IPTi 2nd dose", value: attndObj.received_malaria_ipt2, table: table, key: "received_malaria_ipt2" });
      attndDisplay.push({ name: "Total who received malaria IPTi 3rd dose", value: attndObj.received_malaria_ipt3, table: table, key: "received_malaria_ipt3" });
      attndDisplay.push({ name: "Total who received IFAs -Iron and Folic Acid supplements", value: attndObj.received_hematinics, table: table, key: "received_hematinics" });
      attndDisplay.push({ name: "Postnatal visit Total", value: attndObj.postnatal_attendance_total, table: table, key: "postnatal_attendance_total" });
      //attndDisplay.push({ name: "Edinburgh Postnatal Depression Scale (EPDS) administered Total", value: attndObj.postnatal_epds_administered_total, table: table, key: "postnatal_epds_administered_total" });
      //attndDisplay.push({ name: "Based on EPDS meets the criteria for depression", value: attndObj.postnatal_epds_depression_criteria_total, table: table, key: "postnatal_epds_depression_criteria_total" });
      //attndDisplay.push({ name: "Based on EPDS patient is at risk of harming herself", value: attndObj.postnatal_epds_riskofhurting_criteria_total, table: table, key: "postnatal_epds_riskofhurting_criteria_total" });
    }
    catch (e) {
      console.log(e);
    }
    return attndDisplay;
  }

  getLaborandDeliveryData(laborObj: labordeliverystat): any[] {
    if (laborObj == null) return [];

    let laborDisplay = [];
    try {
      let table = "LABOR_DELIVERY_STAT";
      laborDisplay.push({ name: "Spontaneous vaginal Total", value: laborObj.spontaneous_vaginal_total, table: table, key: "spontaneous_vaginal_total" });
      laborDisplay.push({ name: "Assisted total", value: laborObj.assisted_total, table: table, key: "assisted_total" });
      laborDisplay.push({ name: "Caesarean Section Total", value: laborObj.caesarean_section_total, table: table, key: "caesarean_section_total" });
      laborDisplay.push({ name: "Pre-term Total", value: laborObj.preterm_total, table: table, key: "preterm_total" });
      laborDisplay.push({ name: "Stillbirth Total", value: laborObj.stillbirth_total, table: table, key: "stillbirth_total" });
      laborDisplay.push({ name: "Maternal death Total", value: laborObj.maternal_death_total, table: table, key: "maternal_death_total" });

      laborDisplay.push({ name: "Fetal death Total", value: laborObj.fetal_death_total, table: table, key: "fetal_death_total" });
      laborDisplay.push({ name: "Fetus and/or newborn affected complications Total", value: laborObj.fetus_newborn_complications_total, table: table, key: "fetus_newborn_complications_total" });
      laborDisplay.push({ name: "Complication of pregnancy, childbirth and puerperium Total", value: laborObj.complications_total, table: table, key: "complications_total" });

      laborDisplay.push({ name: "Live birth and positive for HIV", value: laborObj.hiv_positive_live_birth_total, table: table, key: "hiv_positive_live_birth_total" });
      laborDisplay.push({ name: "Total positive for HIV", value: laborObj.hiv_positive_total, table: table, key: "hiv_positive_total" });
      laborDisplay.push({ name: "Live birth and positive for HEP-B", value: laborObj.hepb_positive_live_birth_total, table: table, key: "hepb_positive_live_birth_total" });
      laborDisplay.push({ name: "Total positive for HEP-B", value: laborObj.hepb_positive_total, table: table, key: "hepb_positive_total" });
      laborDisplay.push({ name: "Live birth and positive for HEP-C", value: laborObj.hepc_positive_live_birth_total, table: table, key: "hepc_positive_live_birth_total" });
      laborDisplay.push({ name: "Total positive for HEP-C", value: laborObj.hepc_positive_total, table: table, key: "hepc_positive_total" });
      laborDisplay.push({ name: "Live birth and positive for VDRL", value: laborObj.vdrl_positive_live_birth_total, table: table, key: "vdrl_positive_live_birth_total" });
      laborDisplay.push({ name: "Total positive for VDRL", value: laborObj.vdrl_positive_total, table: table, key: "vdrl_positive_total" });

      laborDisplay.push({ name: "Total male live births < 2.5kg.", value: laborObj.male_live_birth_lessthan_2_5kg_total, table: table, key: "male_live_birth_lessthan_2_5kg_total" });
      laborDisplay.push({ name: "Total female live births < 2.5kg.", value: laborObj.female_live_birth_lessthan_2_5kg_total, table: table, key: "female_live_birth_lessthan_2_5kg_total" });

      laborDisplay.push({ name: "Total male live births > 2.5kg.", value: laborObj.male_live_birth_greaterthan_2_5kg_total, table: table, key: "male_live_birth_greaterthan_2_5kg_total" });
      laborDisplay.push({ name: "Total female live births > 2.5kg.", value: laborObj.female_live_birth_greaterthan_2_5kg_total, table: table, key: "female_live_birth_greaterthan_2_5kg_total" });

      laborDisplay.push({ name: "Total male live births", value: laborObj.male_live_birth_total, table: table, key: "male_live_birth_total" });
      laborDisplay.push({ name: "Total female live births", value: laborObj.female_live_birth_total, table: table, key: "female_live_birth_total" });

      laborDisplay.push({ name: "Total unknown live births", value: laborObj.unknown_live_birth_total, table: table, key: "female_live_birth_total" });
      laborDisplay.push({ name: "Total male stillbirths", value: laborObj.male_stillbirth_total, table: table, key: "male_stillbirth_total" });
      laborDisplay.push({ name: "Total female stillbirths", value: laborObj.female_stillbirth_total, table: table, key: "female_stillbirth_total" });
      laborDisplay.push({ name: "Total unknown stillbirths", value: laborObj.unknown_stillbirth_total, table: table, key: "unknown_stillbirth_total" });

      laborDisplay.push({ name: "Labor and Delivery Total", value: laborObj.total, table: table, key: "total" });
    }
    catch (e) {
      console.log(e);
    }
    return laborDisplay;
  }

  getLaborandDeliveryByAgeData(laborObj: labordeliverystat): any[] {
    if (laborObj == null) return [];

    let laborDisplay = [];
    try {
      let table = "LABOR_DELIVERY_STAT";
      laborDisplay.push({
        name: "Under 15",
        value: laborObj.no_of_deliveries_under_15,
        male: laborObj.no_of_male_live_births_under_15,
        female: laborObj.no_of_female_live_births_under_15,
        multiple: laborObj.no_of_multiple_deliveries_under_15,
        malestillbirth: laborObj.no_of_male_stillbirths_under_15,
        femalestillbirth: laborObj.no_of_female_stillbirths_under_15,
        maternaldeath: laborObj.no_of_maternal_deaths_under_15,
        table: table, key: "under15"
      });
      laborDisplay.push({
        name: "15 to 19",
        value: laborObj.no_of_deliveries_15_19,
        male: laborObj.no_of_male_live_births_15_19,
        female: laborObj.no_of_female_live_births_15_19,
        multiple: laborObj.no_of_multiple_deliveries_15_19,
        malestillbirth: laborObj.no_of_male_stillbirths_15_19,
        femalestillbirth: laborObj.no_of_female_stillbirths_15_19,
        maternaldeath: laborObj.no_of_maternal_deaths_15_19,
        table: table, key: "15to19"
      });
      laborDisplay.push({
        name: "20 to 24",
        value: laborObj.no_of_deliveries_20_24,
        male: laborObj.no_of_male_live_births_20_24,
        female: laborObj.no_of_female_live_births_20_24,
        multiple: laborObj.no_of_multiple_deliveries_20_24,
        malestillbirth: laborObj.no_of_male_stillbirths_20_24,
        femalestillbirth: laborObj.no_of_female_stillbirths_20_24,
        maternaldeath: laborObj.no_of_maternal_deaths_20_24,
        table: table, key: "20to24"
      });
      laborDisplay.push({
        name: "25 to 29",
        value: laborObj.no_of_deliveries_25_29,
        male: laborObj.no_of_male_live_births_25_29,
        female: laborObj.no_of_female_live_births_25_29,
        multiple: laborObj.no_of_multiple_deliveries_25_29,
        malestillbirth: laborObj.no_of_male_stillbirths_25_29,
        femalestillbirth: laborObj.no_of_female_stillbirths_25_29,
        maternaldeath: laborObj.no_of_maternal_deaths_25_29,
        table: table, key: "25to29"
      });
      laborDisplay.push({
        name: "30 to 34",
        value: laborObj.no_of_deliveries_30_34,
        male: laborObj.no_of_male_live_births_30_34,
        female: laborObj.no_of_female_live_births_30_34,
        multiple: laborObj.no_of_multiple_deliveries_30_34,
        malestillbirth: laborObj.no_of_male_stillbirths_30_34,
        femalestillbirth: laborObj.no_of_female_stillbirths_30_34,
        maternaldeath: laborObj.no_of_maternal_deaths_30_34,
        table: table, key: "30to34"
      });
      laborDisplay.push({
        name: "35 to 39",
        value: laborObj.no_of_deliveries_35_39,
        male: laborObj.no_of_male_live_births_35_39,
        female: laborObj.no_of_female_live_births_35_39,
        multiple: laborObj.no_of_multiple_deliveries_35_39,
        malestillbirth: laborObj.no_of_male_stillbirths_35_39,
        femalestillbirth: laborObj.no_of_female_stillbirths_35_39,
        maternaldeath: laborObj.no_of_maternal_deaths_35_39,
        table: table, key: "35to39"
      });
      laborDisplay.push({
        name: "40 and older",
        value: laborObj.no_of_deliveries_40_older,
        male: laborObj.no_of_male_live_births_40_older,
        female: laborObj.no_of_female_live_births_40_older,
        multiple: laborObj.no_of_multiple_deliveries_40_older,
        malestillbirth: laborObj.no_of_male_stillbirths_40_older,
        femalestillbirth: laborObj.no_of_female_stillbirths_40_older,
        maternaldeath: laborObj.no_of_maternal_deaths_40_older,
        table: table, key: "40andolder"
      });
      laborDisplay.push({
        name: "Total",
        value: laborObj.no_of_deliveries_total,
        male: laborObj.no_of_male_live_births_total,
        female: laborObj.no_of_female_live_births_total,
        multiple: laborObj.no_of_multiple_deliveries_total,
        malestillbirth: laborObj.no_of_male_stillbirths_total,
        femalestillbirth: laborObj.no_of_female_stillbirths_total,
        maternaldeath: laborObj.no_of_maternal_deaths_total,
        table: table, key: "total"
      });
    }
    catch (e) {
      console.log(e);
    }
    return laborDisplay;
  }

  getAccountingSummaryData(asumObj: accountingsummary): any[] {
    if (asumObj == null) return [];

    let asumDisplay = [];
    try {

      let table = "ACCOUNTING_SUMMARY";
      asumDisplay.push({ name: "Total AR", value: asumObj.current_ar_total, table: table, key: "current_ar_total" });
      asumDisplay.push({ name: "Total Revenue", value: asumObj.current_revenue_total, table: table, key: "current_revenue_total" });
      asumDisplay.push({ name: "Total Collected", value: asumObj.collected_total, table: table, key: "collected_total" });
      asumDisplay.push({ name: "Overdue 30-Days", value: asumObj.overdue_30_days, table: table, key: "overdue_30_days" });
      asumDisplay.push({ name: "Overdue 60-Days", value: asumObj.overdue_60_days, table: table, key: "overdue_60_days" });
      asumDisplay.push({ name: "Overdue 90-Days", value: asumObj.overdue_90_days, table: table, key: "overdue_90_days" });
      asumDisplay.push({ name: "Overdue 120-Days", value: asumObj.overdue_120_days, table: table, key: "overdue_120_days" });
      asumDisplay.push({ name: "Overdue More-Than-150-Days", value: asumObj.overdue_morethan150_days, table: table, key: "overdue_morethan150_days" });
    }
    catch (e) {
      console.log(e);
    }
    return asumDisplay;
  }

  getLodgeMembershipSummaryData(lodgesumObj: lodgemembershipsummary): any[] {
    if (lodgesumObj == null) return [];

    let asumDisplay = [];
    try {
      let table = "LODGE_MEMBERSHIP_SUMMARY";
      asumDisplay.push({ name: "CHARTER NO: Local Number " + lodgesumObj.charter_number.toString() + ",   " + lodgesumObj.organization_name, value: "", table: table, key: "line1" });
      asumDisplay.push({ name: "ADDRESS: " + lodgesumObj.street1 + " " + lodgesumObj.street2, value: "", table: table, key: "line2" });
      asumDisplay.push({ name: lodgesumObj.city + " " + lodgesumObj.province + " " + lodgesumObj.state_id + " " + lodgesumObj.postal_code + " " + lodgesumObj.country_id, value: "", table: table, key: "line3" });
      asumDisplay.push({ name: "", value: "", table: table, key: "line4" });
      asumDisplay.push({
        name: "REPORT FOR THE MONTH OF: " + lodgesumObj.remit_period
          + ":   STARTING:    " + Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(lodgesumObj.starting_date), null, false)
          + "     ENDING:    " + Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(lodgesumObj.ending_date), null, false), value: "", table: table, key: "line5"
      });

      asumDisplay.push({ name: "TO THE EXECUTIVE COUNCIL: We hereby desire to inform you that CHARTER NO:  Local Number " + lodgesumObj.charter_number.toString(), value: "", table: table, key: "line6" });
      asumDisplay.push({ name: "IS FUNCTIONING:  " + lodgesumObj.functioning_status, value: "", table: table, key: "line7" });
      asumDisplay.push({ name: "REGULAR MEETING DATES & PLACE:  " + lodgesumObj.meeting_location, value: "", table: table, key: "line8" });
      asumDisplay.push({ name: "FUNCTIONS HELD DURING MONTH: " + lodgesumObj.activities, value: "", table: table, key: "line9" });
      asumDisplay.push({ name: "", value: "", table: table, key: "line10" });
      asumDisplay.push({ name: "OTHER ACTIVITIES: " + lodgesumObj.other_activities, value: "", table: table, key: "line11" });
      asumDisplay.push({ name: "", value: "", table: table, key: "line12" });
      asumDisplay.push({ name: "TRANSFERS: ", value: "", table: table, key: "line13" });
      asumDisplay.push({ name: "- 1). " + (lodgesumObj.transfer_name1.length == 0 ? "N/A" : lodgesumObj.transfer_name1) + " Transferred To: " + lodgesumObj.transfer_to_charter1 + " Effective: " + Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(lodgesumObj.transfer_effective_date1), null, false), value: "", table: table, key: "line14" });
      asumDisplay.push({ name: "- 2). " + (lodgesumObj.transfer_name2.length == 0 ? "N/A" : lodgesumObj.transfer_name2) + " Transferred To: " + lodgesumObj.transfer_to_charter2 + " Effective: " + Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(lodgesumObj.transfer_effective_date2), null, false), value: "", table: table, key: "line15" });
      asumDisplay.push({ name: "", value: "", table: table, key: "line16" });
      asumDisplay.push({
        name: "AMOUNTS REMITTED TO HEADQUARTERS DURING THE MONTH OF: " + lodgesumObj.remit_period + "  Total = " + Iceutility.toCurrency(lodgesumObj.remitted_amount, this.currencies.length > 0 ? this.currencies[0].code : ""), value: "", table: table, key: "line17"
      });
    }
    catch (e) {
      console.log(e);
    }
    return asumDisplay;
  }

  getRevenueSummaryData(revenues: incomerevenuejournal[]): any[] {
    if (revenues == null) return [];

    let asumDisplay = [];
    let total = 0.0;

    try {
      let table = "REVENUE_SUMMARY";
      let sumInfo = {};
      for (let irev = 0; irev < revenues.length; irev++) {
        let rev = revenues[irev];
        if (rev == null) continue;

        let key = rev.journal_code + ":" + rev.journal_desc;
        if (sumInfo[key] == null) {
          let sumDat = { name: rev.journal_desc + (rev.journal_code.length == 0 ? "" : " (" + rev.journal_code + ")"), value: 0, table: table, key: key };
          sumInfo[key] = sumDat;
        }

        sumInfo[key].value += Iceutility.toDouble(rev.credit);
        total += Iceutility.toDouble(rev.credit);
      }

      for (let sumKey of Object.keys(sumInfo)) {
        let sumDat = sumInfo[sumKey];
        sumDat.value = Iceutility.toCurrency(sumDat.value, this.currencies.length > 0 ? this.currencies[0].code : "");
        asumDisplay.push(sumDat);
      }

      asumDisplay.push({
        name: "TOTAL ", value: Iceutility.toCurrency(total, this.currencies.length > 0 ? this.currencies[0].code : ""), table: table, key: "total" });
    }
    catch (e) {
      console.log(e);
    }
    return asumDisplay;
  }

  getRevenueFromARSummaryData(revenues: assetjournal[]): any[] {
    if (revenues == null) return [];

    let asumDisplay = [];
    let total = 0.0;

    try {
      let table = "REVENUE_SUMMARY";
      let sumInfo = {};
      for (let irev = 0; irev < revenues.length; irev++) {
        let rev = revenues[irev];
        if (rev == null) continue;

        let key = rev.journal_code + ":" + rev.journal_desc;
        if (sumInfo[key] == null) {
          let sumDat = { name: rev.journal_desc + (rev.journal_code.length == 0 ? "" : " (" + rev.journal_code + ")"), value: 0, table: table, key: key };
          sumInfo[key] = sumDat;
        }

        sumInfo[key].value += Iceutility.toDouble(rev.debit);
        total += Iceutility.toDouble(rev.debit);
      }

      for (let sumKey of Object.keys(sumInfo)) {
        let sumDat = sumInfo[sumKey];
        sumDat.value = Iceutility.toCurrency(sumDat.value, this.currencies.length > 0 ? this.currencies[0].code : "");
        asumDisplay.push(sumDat);
      }

      asumDisplay.push({
        name: "TOTAL ", value: Iceutility.toCurrency(total, this.currencies.length > 0 ? this.currencies[0].code : ""), table: table, key: "total"
      });
    }
    catch (e) {
      console.log(e);
    }
    return asumDisplay;
  }

  getReportReviewersData(rvwerdata: reviewer[]): any[] {
    if (rvwerdata == null) return [];
    let rvwerDisplay = [];

    try {
      for (let irvw = 0; irvw < rvwerdata.length; irvw++) {
        let rvw = rvwerdata[irvw];
        if (rvw == null) continue;

        let esign = rvw.data_to_sign.length > 0 ? "E-SIGN(" + rvw.data_to_sign.substring(rvw.data_to_sign.length - 7) + ")" : "";
        let disRvw = {
          title_of_reviewer: rvw.title_of_reviewer,
          reviewed_by: rvw.reviewed_by,
          signature_data: rvw.signature_data,
          reviewed_date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rvw.reviewed_date)),
          data_to_sign: esign,
          reviewer_key: rvw.reviewer_key
        }
        rvwerDisplay.push(disRvw);
      }

        rvwerDisplay.push({
          title_of_reviewer: "These signatures are verified and authenticated by ICEMEDX; governed by the E-Sign Act (The Electronic Signatures in Global and National Commerce Act)",
          reviewed_by: "",
          signature_data: "",
          reviewed_date: "",
          data_to_sign: "",
          reviewer_key: ""
        });
    }
    catch (e) {
      console.log(e);
    }
    return rvwerDisplay;
  }

  getPatientData(): any[] {

    let patientDisplay = [];
    try {
      let table = "PATIENT_STAT";

      for (let ipt = 0; ipt < this.reportData.PATIENTSTATS.length; ipt++) {
        let ptstat: patientstat = this.reportData.PATIENTSTATS[ipt];
        if (ptstat == null) continue;

        patientDisplay.push({ name: ptstat.trans_account, codes: ptstat.ssn_fedid_num, table: table, key: ptstat.trans_account });
      }
    }
    catch (e) {
      console.log(e);
    }
    return patientDisplay;
  }

  computeAverage(total: number, count: number): number {
    if (Iceutility.isdefined(total) == false) return 0.0;
    if (Iceutility.isdefined(count) == false || count == 0) return 0.0;
    return total / count;
  }

  setDeliveryChartData(): void {
    if (this.deliverySeriesChart.properties == null) this.deliverySeriesChart.properties = {};
    if (this.birthrateSeriesChart.properties == null) this.birthrateSeriesChart.properties = {};

    this.deliverySeriesChart.properties.chartOptions = {
      title: 'Correlation between Gestational period from LMP, age ' +
        'and population of pregnant patients',
      hAxis: { title: 'Gestational period from LMP' },
      vAxis: { title: 'Average age' },
      bubble: { textStyle: { fontSize: 11 } }
    };

    this.birthrateSeriesChart.properties.chartOptions = {
      title: 'Correlation between Gestational period from LMP, age, weight ' +
        'and malaria vaccine of pregnant patients',
      hAxis: { title: 'Gestational period from LMP' },
      vAxis: { title: 'Average age' },
      bubble: { textStyle: { fontSize: 11 } }
    };

    let agestat = {}
    let grp1 = 'Spontaneous';
    let grp2 = 'Assisted';
    let grp3 = 'Caesarean';
    let grp4 = 'Preterm';
    let grp5 = 'Stillbirth';
    let grp6 = 'Maternal-death';
    let grp7 = 'Fetal-death';

    let grp1st = '1st-Tri';
    let grp2nd = '2nd-Tri';
    let grp3rd = '3rd-Tri';
    let grpLow = 'Low-Weight';
    let grpHigh = 'Normal-Weight';
    let grpMalariaSome = 'Some-Malaria';
    let grpMalariaAll = 'All-Malaria';
    let grpMalariaNone = 'No-Malaria';


    agestat[grp1] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grp2] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grp3] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grp4] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grp5] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grp6] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grp7] = { count: 0, weeks: 0.0, age: 0.0 };

    agestat[grp1st] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grp2nd] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grp3rd] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grpLow] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grpHigh] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grpMalariaSome] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grpMalariaAll] = { count: 0, weeks: 0.0, age: 0.0 };
    agestat[grpMalariaNone] = { count: 0, weeks: 0.0, age: 0.0 };

    for (let ipt = 0; ipt < this.reportData.PATIENTSTATS.length; ipt++) {
      let ptstat: patientstat = this.reportData.PATIENTSTATS[ipt];
      if (ptstat == null) continue;
      let ld: labordeliverystat = ptstat.LABOR_DELIVERY_STAT[0];
      if (ld == null) continue;
      if (Iceutility.toLong(ld.total) == 0) continue; // only do deliveries      
      let weeks = Iceutility.toDouble(ptstat.weeks);
      if (weeks == 0.0) continue; // only do ones that have weeks      

      let age = Iceutility.toDouble(ptstat.age)
      if (ld.spontaneous_vaginal_total > 0) {
        agestat[grp1].count++;
        agestat[grp1].weeks += weeks;
        agestat[grp1].age += age;
      }

      if (ld.assisted_total > 0) {
        agestat[grp2].count++;
        agestat[grp2].weeks += weeks;
        agestat[grp2].age += age;
      }

      if (ld.caesarean_section_total > 0) {
        agestat[grp3].count++;
        agestat[grp3].weeks += weeks;
        agestat[grp3].age += age;
      }

      if (ld.preterm_total > 0) {
        agestat[grp4].count++;
        agestat[grp4].weeks += weeks;
        agestat[grp4].age += age;
      }

      if (ld.stillbirth_total > 0) {
        agestat[grp5].count++;
        agestat[grp5].weeks += weeks;
        agestat[grp5].age += age;
      }

      if (ld.maternal_death_total > 0) {
        agestat[grp6].count++;
        agestat[grp6].weeks += weeks;
        agestat[grp6].age += age;
      }

      if (ld.fetal_death_total > 0) {
        agestat[grp7].count++;
        agestat[grp7].weeks += weeks;
        agestat[grp7].age += age;
      }

      if (ptstat.weeks < 14.0) {
        agestat[grp1st].count++;
        agestat[grp1st].weeks += weeks;
        agestat[grp1st].age += age;
      }
      else if (weeks >= 14.0 && weeks <= 27.0) {
        agestat[grp2nd].count++;
        agestat[grp2nd].weeks += weeks;
        agestat[grp2nd].age += age;
      }
      else if (ptstat.weeks >= 28.0) {
        agestat[grp3rd].count++;
        agestat[grp3rd].weeks += weeks;
        agestat[grp3rd].age += age;
      }

      if (Iceutility.toLong(ld.male_live_birth_greaterthan_2_5kg_total) > 0
        || Iceutility.toLong(ld.female_live_birth_greaterthan_2_5kg_total) > 0) {
        agestat[grpHigh].count += (Iceutility.toLong(ld.male_live_birth_greaterthan_2_5kg_total) + Iceutility.toLong(ld.female_live_birth_greaterthan_2_5kg_total));
        agestat[grpHigh].weeks += weeks;
        agestat[grpHigh].age += age;
      }

      if (Iceutility.toLong(ld.male_live_birth_lessthan_2_5kg_total) > 0
        || Iceutility.toLong(ld.female_live_birth_lessthan_2_5kg_total) > 0) {
        agestat[grpLow].count += (Iceutility.toLong(ld.male_live_birth_lessthan_2_5kg_total) + Iceutility.toLong(ld.female_live_birth_lessthan_2_5kg_total));
        agestat[grpLow].weeks += weeks;
        agestat[grpLow].age += age;
      }

      let anc: antenatalattendancestat = ptstat.ANTENATAL_ATTENDANCE_STAT[0];
      if (anc == null) continue;

      let malariascore = anc.received_malaria_ipt1 + anc.received_malaria_ipt1 + anc.received_malaria_ipt1;
      if (malariascore > 2) {
        agestat[grpMalariaAll].count++;
        agestat[grpMalariaAll].weeks += weeks;
        agestat[grpMalariaAll].age += age;
      }
      else if (malariascore > 0){
        agestat[grpMalariaSome].count++;
        agestat[grpMalariaSome].weeks += weeks;
        agestat[grpMalariaSome].age += age;
      }
      else if (malariascore > 0) {
        agestat[grpMalariaNone].count++;
        agestat[grpMalariaNone].weeks += weeks;
        agestat[grpMalariaNone].age += age;
      }
    }

    this.deliverySeriesChart.setOptions([
      ['ID', 'Gestational period from LMP', 'Age', 'Outcome', 'Count'],
      [grp1, this.computeAverage(agestat[grp1].weeks, agestat[grp1].count), this.computeAverage(agestat[grp1].age, agestat[grp1].count), 'Spontaneous vaginal', agestat[grp1].count],
      [grp2, this.computeAverage(agestat[grp2].weeks, agestat[grp2].count), this.computeAverage(agestat[grp2].age, agestat[grp2].count), 'Assisted', agestat[grp2].count],
      [grp3, this.computeAverage(agestat[grp3].weeks, agestat[grp3].count), this.computeAverage(agestat[grp3].age, agestat[grp3].count), 'Caesarean Section', agestat[grp3].count],
      [grp4, this.computeAverage(agestat[grp4].weeks, agestat[grp4].count), this.computeAverage(agestat[grp4].age, agestat[grp4].count), 'Pre-term', agestat[grp4].count],
      [grp5, this.computeAverage(agestat[grp5].weeks, agestat[grp5].count), this.computeAverage(agestat[grp5].age, agestat[grp5].count), 'Stillbirth', agestat[grp5].count],
      [grp6, this.computeAverage(agestat[grp6].weeks, agestat[grp6].count), this.computeAverage(agestat[grp6].age, agestat[grp6].count), 'Maternal death', agestat[grp6].count],
      [grp7, this.computeAverage(agestat[grp7].weeks, agestat[grp7].count), this.computeAverage(agestat[grp7].age, agestat[grp7].count), 'Fetal death', agestat[grp7].count]
    ]);
    this.deliverySeriesChart.loadGoogleChart("deliverychart", ChartTypes.ctBubble);

    this.birthrateSeriesChart.setOptions([
      ['ID', 'Gestational period from LMP', 'Age', 'Outcome', 'Count'],
      [grp1st, this.computeAverage(agestat[grp1st].weeks, agestat[grp1st].count), this.computeAverage(agestat[grp1st].age, agestat[grp1st].count), '1st. Trimester', agestat[grp1st].count],
      [grp2nd, this.computeAverage(agestat[grp2nd].weeks, agestat[grp2nd].count), this.computeAverage(agestat[grp2nd].age, agestat[grp2nd].count), '2nd. Trimester', agestat[grp2nd].count],
      [grp3rd, this.computeAverage(agestat[grp3rd].weeks, agestat[grp3rd].count), this.computeAverage(agestat[grp3rd].age, agestat[grp3rd].count), '3rd. Trimester', agestat[grp3rd].count],
      [grpLow, this.computeAverage(agestat[grpLow].weeks, agestat[grpLow].count), this.computeAverage(agestat[grpLow].age, agestat[grpLow].count), 'Low birth weight', agestat[grpLow].count],
      [grpHigh, this.computeAverage(agestat[grpHigh].weeks, agestat[grpHigh].count), this.computeAverage(agestat[grpHigh].age, agestat[grpHigh].count), 'Normal birth weight', agestat[grpHigh].count],
      [grpMalariaSome, this.computeAverage(agestat[grpMalariaSome].weeks, agestat[grpMalariaSome].count), this.computeAverage(agestat[grpMalariaSome].age, agestat[grpMalariaSome].count), 'Administered some of malaria vaccine', agestat[grpMalariaSome].count],
      [grpMalariaAll, this.computeAverage(agestat[grpMalariaAll].weeks, agestat[grpMalariaAll].count), this.computeAverage(agestat[grpMalariaAll].age, agestat[grpMalariaAll].count), 'Administered malaria vaccine', agestat[grpMalariaAll].count],
      [grpMalariaNone, this.computeAverage(agestat[grpMalariaNone].weeks, agestat[grpMalariaNone].count), this.computeAverage(agestat[grpMalariaNone].age, agestat[grpMalariaNone].count), 'No malaria vaccine', agestat[grpMalariaNone].count]
    ]);
    this.birthrateSeriesChart.loadGoogleChart("birthratechart", ChartTypes.ctBubble);
  }

  createOBSection(code: string): IcepanelsectionSettings {
    let section: IcepanelsectionSettings = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let tables: IcemattableSettings[] = [];

      if (code == "REPTEMPL-MHAPNC" && Iceutility.isdefined(this.reportData.ANTENATAL_ATTENDANCE_STAT) && this.reportData.ANTENATAL_ATTENDANCE_STAT.length > 0) {
        if (this.attendanceChart == null) {
          this.attendanceChart = new IcecontrolSettings("icegooglechart", { width: "250px" }, null, null, "attendchart", "ANC First Visit Attendance");

          controls.push(this.attendanceChart);
          //controls.push(this.deliverySeriesChart);
          //controls.push(this.birthrateSeriesChart);
        }

        if (this.ancAttendanceTable == null) {
          this.ancAttendanceTable = this.setupAntenatal(this.ancAttendanceData);
          tables.push(this.ancAttendanceTable);

          this.ancAttendanceTable.setShowTable(true);
          let colDef: iceColumnDefinition = this.ancAttendanceTable.getColumn("name");
          if (colDef) colDef.displayName = colDef.displayName + " (N=" + this.reportData.ANTENATAL_ATTENDANCE_STAT[0].antenatal_total.toString() + ", includes all OB patient's in the above period.)"
          let attndObj: antenatalattendancestat = this.reportData.ANTENATAL_ATTENDANCE_STAT[0];
          this.ancAttendanceData.data = this.getAntenatalData(attndObj);

          this.attendanceChart.setOptions([
            { name: 'Attendance', value: 'Totals' },
            { name: 'Before 14 weeks', value: Iceutility.toLong(attndObj.antenatal_first_visit_before_14weeks) },
            { name: 'Between 15 and 20 weeks', value: Iceutility.toLong(attndObj.antenatal_first_visit_before_20weeks) },
            { name: 'Between 21 and 27 weeks', value: Iceutility.toLong(attndObj.antenatal_first_20_weeks_or_later) },
            { name: '28 weeks or later', value: Iceutility.toLong(attndObj.antenatal_first_28_weeks_or_later) },
          ]);
          this.attendanceChart.loadGoogleChart("attendchart", ChartTypes.ctPie);
        }
      }

      if (code == "REPTEMPL-MHLD" && Iceutility.isdefined(this.reportData.LABOR_DELIVERY_STAT) && this.reportData.LABOR_DELIVERY_STAT.length > 0) {
        //////////////////////////////////
        // Remove until more data-points are collected
        //this.deliverySeriesChart = new IcecontrolSettings("icegooglechart", { width: "250px" }, null, null, "deliverychart", "Pregnancy Outcomes by Age");
        //this.birthrateSeriesChart = new IcecontrolSettings("icegooglechart", { width: "250px" }, null, null, "birthratechart", "Pregnancy Outcomes by Age-Weight");     

        if (this.laborDeliveryTable == null) {
          this.laborDeliveryTable = this.setLaborandDelivery(this.laborDeliveryData);
          tables.push(this.laborDeliveryTable);
        }

        if (this.deliveryByAgeTable == null) {
          this.deliveryByAgeTable = this.setLaborandDeliveryByAge(this.deliveryByAgeData);
          tables.push(this.deliveryByAgeTable);
        }

        //////////////////////////////////
        // Remove until more data-points are collected
        //this.setDeliveryChartData();

        this.laborDeliveryTable.setShowTable(true);
        let colDef: iceColumnDefinition = this.laborDeliveryTable.getColumn("name");
        if (colDef) colDef.displayName = colDef.displayName + " (N=" + this.reportData.LABOR_DELIVERY_STAT[0].total.toString() + ", only includes patient's who delivered in the above period.)"

        let laborObj: labordeliverystat = this.reportData.LABOR_DELIVERY_STAT[0];
        this.laborDeliveryData.data = this.getLaborandDeliveryData(laborObj);
        this.deliveryByAgeData.data = this.getLaborandDeliveryByAgeData(laborObj);
      }

      if (this.reportData.PATIENTSTATS.length > 0) {
        if (this.patientTable == null) {
          this.patientTable = this.setupPatients(this.patientData);
          tables.push(this.patientTable);
        }
      }

      if (controls.length > 0 || tables.length > 0) {
        section = new IcepanelsectionSettings("OBSection", { class: [""], styles: { width: "100%" } }, null, controls, tables)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
      }
    }
    catch (e) {
      console.log(e);
    }

    return section;
  }

  createAccountingSummary(): IcepanelsectionSettings {
    let section: IcepanelsectionSettings = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let tables: IcemattableSettings[] = [];
      if (this.reportData.ACCOUNTING_SUMMARY.length > 0) {
        if (this.accountingSummaryChart == null) {
          this.accountingSummaryChart = new IcecontrolSettings("icegooglechart", { width: "250px" }, null, null, "accountsummarychart", "Accounting Summary");

          controls.push(this.accountingSummaryChart);
        }

        if (this.accountingSummaryTable == null) {
          this.accountingSummaryTable = this.setupAccountingSummary(this.accountingSummaryData);
          tables.push(this.accountingSummaryTable);

          this.accountingSummaryTable.setShowTable(true);
          let asumObj: accountingsummary = this.reportData.ACCOUNTING_SUMMARY[0];
          this.accountingSummaryData.data = this.getAccountingSummaryData(asumObj);

          let overdue = Iceutility.toDouble(asumObj.overdue_morethan150_days)
            + Iceutility.toDouble(asumObj.overdue_120_days)
            + Iceutility.toDouble(asumObj.overdue_90_days)
            + Iceutility.toDouble(asumObj.overdue_60_days)
            + Iceutility.toDouble(asumObj.overdue_30_days);

          this.accountingSummaryChart.setOptions([
            { name: 'Element', value: 'Totals' },
            { name: 'Total AR', value: Iceutility.toDouble(asumObj.current_ar_total), color: 'yellow' },
            { name: 'Total Revenue', value: Iceutility.toDouble(asumObj.current_revenue_total), color: 'green' },
            { name: 'Total Collected', value: Iceutility.toDouble(asumObj.collected_total), color: 'gold' },
            { name: 'Total Overdue', value: overdue, color: 'red' },
          ]);
          this.accountingSummaryChart.loadGoogleChart("accountsummarychart", ChartTypes.ctBar);
        }

        if (this.reportData.PATIENTSTATS.length > 0) {
          if (this.patientTable == null) {
            this.patientTable = this.setupPatients(this.patientData);
            tables.push(this.patientTable);
          }
        }
      }

      if (controls.length > 0 || tables.length > 0) {
        section = new IcepanelsectionSettings("AccountingSummarySection", { class: ["yalla"], styles: { width: "100%" } }, null, controls, tables)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
      }
    }
    catch (e) {
      console.log(e);
    }

    return section;
  }

  createLodgeMembershipSummary(template: reporttemplate): IcepanelsectionSettings {
    if (template == null) return null;
    debugger;
    let section: IcepanelsectionSettings = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let tables: IcemattableSettings[] = [];
      if (template.LODGE_MEMBERSHIP_SUMMARY.length > 0) {
        let lodgeMembershipData: MatTableDataSource<any> = new MatTableDataSource<any>([]);
        let lodgeMembershipSummaryTable = this.setupLodgeMembershipSummary(lodgeMembershipData);
        tables.push(lodgeMembershipSummaryTable);

        lodgeMembershipSummaryTable.setShowTable(true);
        let asumObj: lodgemembershipsummary = template.LODGE_MEMBERSHIP_SUMMARY[0];
        lodgeMembershipData.data = this.getLodgeMembershipSummaryData(asumObj);
      }

      if (controls.length > 0 || tables.length > 0) {
        section = new IcepanelsectionSettings("LodgeMembershipSummarySection", { class: ["yalla"], styles: { width: "100%" } }, null, controls, tables)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
      }
    }
    catch (e) {
      console.log(e);
    }

    return section;
  }

  createRevenueSummary(repData: reportdata): IcepanelsectionSettings {
    let section: IcepanelsectionSettings = null;
    try {
      if (repData == null) return section;

      let controls: IcecontrolSettings[] = [];
      let tables: IcemattableSettings[] = [];
      if (repData.REVENUES.length == 0)
        return null;
 
      if (this.revenueSummaryTable == null) {
        this.revenueSummaryTable = this.setupRevenueSummaryTable(this.revenueSummaryData);
        tables.push(this.revenueSummaryTable);
      }

      this.revenueSummaryTable.setShowTable(true);
      let revs = repData.REVENUES;
      this.revenueSummaryData.data = this.getRevenueSummaryData(revs);

      if (controls.length > 0 || tables.length > 0) {
        section = new IcepanelsectionSettings("RevenueSummarySection", { class: ["yalla"], styles: { width: "100%" } }, null, controls, tables)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
      }
    }
    catch (e) {
      console.log(e);
    }

    return section;
  }

  createRevenueFromARSummary(repData: reportdata): IcepanelsectionSettings {
    let section: IcepanelsectionSettings = null;
    if (repData == null) return section;

    try {
      let controls: IcecontrolSettings[] = [];
      let tables: IcemattableSettings[] = [];
      if (repData.REVENUES_FROM_AR.length == 0)
        return null;

      if (this.revenueSummaryTable == null) {
        this.revenueSummaryTable = this.setupRevenueSummaryTable(this.revenueSummaryData);
        tables.push(this.revenueSummaryTable);
      }

      this.revenueSummaryTable.setShowTable(true);
      let revs = repData.REVENUES_FROM_AR;
      this.revenueSummaryData.data = this.getRevenueFromARSummaryData(revs);

      if (controls.length > 0 || tables.length > 0) {
        section = new IcepanelsectionSettings("RevenueSummarySection", { class: ["yalla"], styles: { width: "100%" } }, null, controls, tables)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
      }
    }
    catch (e) {
      console.log(e);
    }

    return section;
  }

  createSigningSection(): IcepanelsectionSettings {
    let section: IcepanelsectionSettings = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let tables: IcemattableSettings[] = [];
      if (this.signTitle == null) {
        let titles = [
          { value: "", name: "No Title" },
          { value: "President", name: "President" },
          { value: "Vice President", name: "Vice President" },
          { value: "Treasurer or CFO", name: "Treasurer or CFO" },
          { value: "R.C. Secretary", name: "R.C. Secretary" },
          { value: "Financial Secretary", name: "Financial Secretary" },
          { value: "Director", name: "Director" },
          { value: "Manager", name: "Manager" },
          { value: "Authorized Agent", name: "Authorized Agent" },
        ];

        this.signTitle = new IcecontrolSettings("iceselect", {
          menuItems: titles,
          width: "250px"
        }, null, null, "SignTitle", "Select Signing Title")
          .setControlName("SignTitle")
          .createFormControl("", []);

        controls.push(this.signTitle);
      }

      controls.push(this.signatureCtrl);

      if (this.signButton == null) {
        this.signButton = new IcecontrolSettings("icepanelbutton", { text: "Sign Report", class: [], glyphClass: "fa-plus" }, null, null, "SignButton");
        controls.push(this.signButton);
      }

      if (controls.length > 0 || tables.length > 0) {
        section = new IcepanelsectionSettings("SigningSection", { class: ["yalla"], styles: { width: "100%" } }, null, controls, tables)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical)
          .setShow(true);

        //setTimeout(() => { section.setShow(false); });
      }
    }
    catch (e) {
      console.log(e);
    }

    return section;
  }

  getDateRangeArray(startDate, endDate): string[] {
    const dates: string[] = [];
    let currentDate = Iceutility.GetLocalDate(startDate);

    while (currentDate <= Iceutility.GetLocalDate(endDate)) {
      dates.push(Iceutility.getDateTextEx(currentDate, "-", false)); // Push a copy of the date
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  }

  getDaySheetTable(sections: IcepanelsectionSettings[], day: string): IcemattableSettings {
    let tempDay = Iceutility.getDateTextEx(day, "-", false);
    let fndSec = sections.filter(s => s.tag == "Day" + tempDay);
    if (fndSec.length == 0) return null;

    let fndTbl = fndSec[0].tables.filter(t => t.tag == "Day" + tempDay);
    if (fndTbl.length == 0) return null;
    return fndTbl[0];
  }

  getDaySheetTableRecord(tbl: IcemattableSettings, act: string): any {
    let fndRec = tbl.iRows.data.filter(r => r['trans_account'] == act);
    if (fndRec.length == 0) return null;
    return fndRec[0];
  }

  createDaySheetTableRecord(tbl: IcemattableSettings, dRec: clinicaldaysheetstat, num: number, name: string, act: string): any {
    dRec["index"] = num;
    dRec["name"] = name;
    dRec["trans_account"] = act;
    return dRec;
  }

  addDaySheetTableRecord(tbl: IcemattableSettings, dayRec: any): void {
    if (tbl.iRows.data == null)
      tbl.iRows.data = [];

    tbl.iRows.data = tbl.iRows.data.concat(dayRec);
  }

  updateDaySheetTableRecord(tbl: IcemattableSettings): void {
    tbl.iRows.data = tbl.iRows.data;
  }

  createDaySheets(repTemp: reporttemplate): IcepanelsectionSettings[] {
    let sections: IcepanelsectionSettings[] = [];
    try {
      let controls: IcecontrolSettings[] = [];
      let tables: IcemattableSettings[] = [];
      let days: string[] = [];
      let fromVal = "", toVal = "";
      // let filterDates = getFilterDates("time_slot_start", repTemp.RPTFILTER);
      // filterDates.fromDate
      // filterDates.toDate
      if (repTemp.RPTFILTER.length == 0) return null;
      let repFilter = repTemp.RPTFILTER[0];
      if (repFilter != null) {
        let parts = repFilter.value.split(",");
        if (parts.length > 0)
          fromVal = parts[0];
        if (parts.length > 1)
          toVal = parts[1];
      }

      days = this.getDateRangeArray(fromVal, toVal);
      for (let iday = 0; iday < days.length; iday++) {
        let dayData = new MatTableDataSource<any>();
        let dayTable = this.setupDaySheet("Day" + days[iday], dayData);
        tables.push(dayTable);

        let section = new IcepanelsectionSettings("Day"+days[iday], { class: ["yalla"], styles: { width: "100%" } }, null, controls, tables)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
        sections.push(section);
      }

      let indexOfPatient = 1;
      for (let ipt = 0; ipt < this.reportData.PATIENTSTATS.length; ipt++) {
        let ptstat = this.reportData.PATIENTSTATS[ipt];
        for (let idys = 0; idys < ptstat.DAYSHEETSTATS.length; idys++) {
          let dyRec = ptstat.DAYSHEETSTATS[idys];
          this.getCodeService().getCodes("DATETIME_CODE", "", dyRec.day, "").subscribe(
            data => {
              if (data && data.length > 0) {
                for (let iDT = 0; iDT < data.length; iDT++) {
                  let bc: basecode = data[iDT];
                  if (dyRec.day == bc.code) {
                    dyRec.day = bc.title;
                  }
                }

                let tbl = this.getDaySheetTable(sections, dyRec.day);
                if (tbl == null) { /*to do log error*/return; }

                let daySheetRec = this.createDaySheetTableRecord(tbl, ptstat.DAYSHEETSTATS[idys], indexOfPatient++, ptstat.getdisplayname(), ptstat.trans_account);
                this.addDaySheetTableRecord(tbl, daySheetRec);
              }
            },
            error => {
              console.log(JSON.stringify(this.getCodeService().getLastErrors()));
            });
        }
      }
    }
    catch (e) {
      console.log(e);
    }

    return sections;
  }

  setupReportReviewers(src: MatTableDataSource<any>): IcepanelsectionSettings {
    let section: IcepanelsectionSettings = null;
    let repActions = [];
    let loginSvc = this.getLoginService();
    if (loginSvc.GetUserName(loginSvc.GetSessionUserInfo(), false).toLowerCase() == this.reportObj.created_user.toLowerCase())
      repActions = [IceTypes.recordQuickActionRemove];

    try {
      this.signedByTable = new IceResponsiveMattableEditSettings("SignedByTable", [
        new iceColumnDefinition("title_of_reviewer", "SIGNED BY", false, false),
        new iceColumnDefinition("reviewed_by", "NAME", false, false),
        new iceColumnDefinition("signature_data", "SIGNATURE", false, false, this.readonlySignatureCtrl),
        new iceColumnDefinition("reviewed_date", "DATE SIGNED", false, false),
        new iceColumnDefinition("data_to_sign", "CONTENT", false, false),
        new iceColumnDefinition("reviewer_key", "", true, true),
        new iceColumnDefinition("QuickActions", "", false, false),
      ],
        src,
        repActions,
        true,
        null,
        true)/*.showAddButton(true)*/; // We are temporarily removing the add button until we can figure out the issue.

      section = new IcepanelsectionSettings("SignedBySection", { class: [""], styles: { width: "100%" } }, null, [], [this.signedByTable])
        .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical);
    }
    catch (e) {

    }
    return section;
  }

  loadReportData(rep: report, repData: reportdata, sections: IcepanelsectionSettings[]): void {
    if (false == Iceutility.isdefined(rep)) return;
    if (false == Iceutility.isdefined(repData)) return;

    for (let itlp = 0; itlp < rep.RPTTEMPLATES.length; itlp++) {
      let templ = rep.RPTTEMPLATES[itlp];
      debugger;
      switch (Iceutility.toLong(rep.report_type)) {
        case IceTypes.ReportType.rtClincialData: {
          let reptmps = this.subTypeCodes.filter(c => c.sub_type == Iceutility.toLong(templ.report_template_type));
          let code = "";
          if (reptmps.length > 0) code = reptmps[0].code;
          if (this.getReportLayoutType() != Report_Layout_Type.rltSectionLayout) {
            let newSection = this.createOBSection(code);
            if (newSection != null)
              sections.push(newSection);
          }
          break;
        }
        case IceTypes.ReportType.rtAccountingSummary: {
          //REPTEMPL-ACCT-SUM
          let lodgeTypes = this.subTypeCodes.filter(c => c.sub_type == Iceutility.toLong(templ.report_template_type) && c.code == "REPTEMPL-ACCT-SUM-LODGE");
          if (lodgeTypes.length > 0) {
            if (this.getReportLayoutType() != Report_Layout_Type.rltSectionLayout) {
              let newSection = this.createLodgeMembershipSummary(templ);
              if (newSection != null)
                sections.push(newSection);

              if (this.reportData.REVENUES.length > 0)
                newSection = this.createRevenueSummary(repData);
              else (this.reportData.REVENUES_FROM_AR.length > 0)
                newSection = this.createRevenueFromARSummary(repData);

              if (newSection != null)
                sections.push(newSection);
            }
          }

          let sumTypes = this.subTypeCodes.filter(c => Iceutility.toLong(templ.report_template_type) == 0 || (c.sub_type == Iceutility.toLong(templ.report_template_type) && c.code == "REPTEMPL-ACCT-SUM"));
          if (sumTypes.length > 0) {
            if (this.getReportLayoutType() != Report_Layout_Type.rltSectionLayout) {
              let newSection = this.createAccountingSummary();
              if (newSection != null)
                sections.push(newSection);
            }
          }

          break;
        }
        case IceTypes.ReportType.rtScheduling: {
          if (templ.template_report_key.length > 0) {
            let foundPanelSec = sections.filter(s => s.tag == "ReportTemplateSection" + templ.report_template_key);
            if (foundPanelSec.length > 0) {
              this.getReportService().getReport(this.apiToUse, this.reportDomain, this.reportDomainType, true, templ.template_report_key).subscribe(
                data => {
                  if (data && data.length > 0 && data[0] != null) {
                    debugger;
                    let retTemplates: report[] = data;
                    let schrpt = new schedulereport(this.getReportService(), this.reportObj, retTemplates, templ, repData);
                    schrpt.create(Report_Mode_Type.modePreview, Command_Type.cmdtOpenReport, templ.template_report_key, "");
                    let iceRptCtrl = new IcecontrolSettings("icereport", { width: "100%" }, null, null, "ReportControl" + templ.template_report_key)
                      .createFormControl(schrpt, []);                                       
                    foundPanelSec[0].controls.push(iceRptCtrl);

                    //let foundReportCtrl = foundPanelSec[0].controls.filter(r => r.id == "ReportControl" + templ.template_report_key);
                    //if (foundReportCtrl.length > 0) {
                    //  let schrpt = new schedulereport(this.getReportService(), this.reportObj, retTemplates, templ, repData);
                    //  schrpt.create(Report_Mode_Type.modePreview, Command_Type.cmdtOpenReport, templ.template_report_key, "");
                    //  foundReportCtrl[0].createFormControl(schrpt, []);
                    //}
                    //this.onLoadReportData(retTemplate, repData, sections);
                  }
                },
                error => {
                  console.log(JSON.stringify(this.getReportService().getLastErrors()));
                });
            }
          }
          else {
            //REPTEMPL-DAYSHEET
            let dayshtTypes = this.subTypeCodes.filter(c => c.sub_type == Iceutility.toLong(templ.report_template_type) && c.code == "REPTEMPL-DAYSHEET");
            if (dayshtTypes.length > 0) {
              if (this.getReportLayoutType() != Report_Layout_Type.rltSectionLayout) {
                let newSections = this.createDaySheets(templ);
                if (newSections != null) {
                  for (let isec = 0; isec < newSections.length; isec++)
                    sections.push(newSections[isec]);
                }
              }
            }
          }
          break;
        }
      }
    }

    if (this.getReportLayoutType() != Report_Layout_Type.rltSectionLayout) {
      let signedBySection = this.setupReportReviewers(this.signedByData);
      if (signedBySection != null) {
        sections.push(signedBySection);
        this.signedByTable.setShowTable(true);
        this.signedByData.data = this.getReportReviewersData(repData.REVIEWS);
      }

      let signingSection = this.createSigningSection();
      if (signingSection != null) {
        sections.push(signingSection);
      }
    }
  }

  onLoadReportData(rep: report, repData: reportdata, sections: IcepanelsectionSettings[]): void {
    //const reportCanvas: HTMLCanvasElement = document.getElementById("reportCanvas") as HTMLCanvasElement;
    const reportCanvas: HTMLCanvasElement = document.getElementById("ReportControl" + rep.report_key) as HTMLCanvasElement;
    this.onPrint(rep, repData, reportCanvas);
  }

  onPrint(rep: report, repData: reportdata, reportCanvas: HTMLCanvasElement): void {
    /*
    // To do we need the src_type to determine what to fill outputRecords with
    rep.initializeReport(); // To do we need to know the primary key
    if (repData.PATIENTSTATS.length == 0) return;

    /////////////////////////////////////
    // To do use report_type to determine how to load outputRecords

    /////////////////
    // ClinicalData Medication
    let ptStat = repData.PATIENTSTATS[0];
    if (ptStat == null) return;

    for (let imedActy = 0; imedActy < ptStat.MEDACTIVITIES.length; imedActy++) {
      let rec = repData.getDataMedActivity(ptStat, ptStat.MEDACTIVITIES[imedActy], rep.outputColumns);
      if (rec != null)
        rep.outputRecords.push(rec);
    }

    /////////////////
    // Schedule Admission
    debugger;
    for (let iptStat = 0; iptStat < repData.PATIENTSTATS.length; iptStat++) {
      let ptStat = repData.PATIENTSTATS[iptStat];
      if (ptStat == null) continue;

      for (let iappt = 0; iappt < ptStat.APPTSTATS.length; iappt++){
        let rec = repData.getDataSchedule(ptStat, ptStat.APPTSTATS[iappt], rep.outputColumns);
        if (rec != null)
          rep.outputRecords.push(rec);
      }
    }

    this.getReportService().onDraw(rep, reportCanvas);
    */
  }

  viewSetup(rep: report): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      if (rep == null) {
        return null;
      }
      this.reportObj = rep;
      this.reportObj.report_type = <IceTypes.ReportType>this.reportObj.report_type;
      let panelTag = "ReportView";
      let panelKey = Iceutility.guid(false);

      let titleControls: IcecontrolSettings[] = [];
      let sections: IcepanelsectionSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];
      this.signatureCtrl = new IcecontrolSettings("icemultimedia", { width: "500", height: "100", showControlButtons: false, value: "", minimalControl: false }, null, null, "multimedia", "")
        .createFormControl("", []);
      this.readonlySignatureCtrl = new IcecontrolSettings("icemultimedia", { width: "500", height: "200", showControlButtons: false, value: "", minimalControl: true, disabled: true }, null, null, "sign_multimedia", "")
        .createFormControl(0, []);

      if (this.getReportMode() == Report_Mode_Type.modePrint) {
      }
      else {
        titleControls = [
          new IcecontrolSettings("iceh2", { value: this.reportObj.rpt_name, width: "250px" }, null, null),
          new IcecontrolSettings("icelabel", { value: "Created by " + this.reportObj.created_user + " on " + Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(this.reportObj.created)), width: "250px" }, null, null),
          new IcecontrolSettings("icelabel", { value: "Modified by " + this.reportObj.modified_user + " on " + Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(this.reportObj.modified)), width: "250px" }, null, null),
          new IcecontrolSettings("icelabel", { value: "Type of Report: " + ReportService.getReportType(this.reportObj.report_type), width: "250px" }, null, null),
          new IcecontrolSettings("icelabel", { value: "Run Frequency: " + ScheduleService.getRecurringType(this.reportObj.recurring_type), width: "250px" }, null, null),
        ];

        let fromVal = "";
        let toVal = "";
        let thisTemplate = null;

        if (Iceutility.isdefined(this.reportObj.RPTTEMPLATES) && this.reportObj.RPTTEMPLATES.length > 0) {
          thisTemplate = this.reportObj.RPTTEMPLATES[0];
          if (thisTemplate != null && Iceutility.isdefined(thisTemplate.RPTFILTER) && thisTemplate.RPTFILTER.length > 0) {
            let thisFilter = thisTemplate.RPTFILTER[0];
            if (thisFilter != null) {
              let parts = thisFilter.value.split(",");
              if (parts.length > 0)
                fromVal = Iceutility.getDateTextEx(parts[0], null, false);
              if (parts.length > 1)
                toVal = Iceutility.getDateTextEx(parts[1], null, false);
            }
          }
        }

        // To do, move this move controls from ReportFilterSection to ReportTitleSection and ReportTemplateSectionXXXXXXX (Primary Key)
        sections = [
          new IcepanelsectionSettings("ReportTitleSection", { class: [""], styles: { width: "100%" } }, null, titleControls, null)
            .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical),
        ];

        debugger;
        if (Iceutility.isdefined(this.reportObj.RPTTEMPLATES)) {
          for (let iRepTempl = 0; iRepTempl < this.reportObj.RPTTEMPLATES.length; iRepTempl++) {
            let thisTemplate = this.reportObj.RPTTEMPLATES[iRepTempl];
            if (thisTemplate != null && Iceutility.isdefined(thisTemplate.RPTFILTER)) {

              let templateControls: IcecontrolSettings[] = [];
              if (thisTemplate.template_report_name != null && thisTemplate.template_report_name.length > 0)
                templateControls.push(new IcecontrolSettings("icelabel", { value: thisTemplate.template_report_name, width: "250px" }, null, null));

              for (let iFiltr = 0; iFiltr < thisTemplate.RPTFILTER.length; iFiltr++) {
                let thisFilter = thisTemplate.RPTFILTER[iFiltr];
                if (thisFilter == null) continue;

                let fromVal = "";
                let toVal = "";
                
                // To do use thisFilter.operatortype to determine how to show the filter values

                let parts = thisFilter.value.split(",");
                if (parts.length > 0)
                  fromVal = Iceutility.getDateTextEx(parts[0], null, false);
                if (parts.length > 1)
                  toVal = Iceutility.getDateTextEx(parts[1], null, false);

                // swith(thisFilter.operatortype) between, equality, etc...

                templateControls.push(new IcecontrolSettings("icelabel", { value: "Date range: " + fromVal + " to " + toVal, width: "250px" }, null, null));
              }

              //templateControls.push(new IcecontrolSettings("icereport", { width: "100%" }, null, null, "ReportControl" + thisTemplate.template_report_key ));

              sections.push(
                new IcepanelsectionSettings("ReportTemplateSection" + thisTemplate.report_template_key, { class: [""], styles: { width: "100%" } }, null, templateControls, null)
                  .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical));
            }
          }
        }

        headerControls = [
          new IcecontrolSettings("icesubmitbutton", { class: "fas fa-edit", width: "50px" }, null, null, "Edit"),
          new IcecontrolSettings("icebutton", { class: "fas fa-filter", width: "50px" }, null, null, "Sample"),
          new IcecontrolSettings("icecancelbutton", { class: "fas fa-times", width: "50px" }, null, null, "CancelReport")
        ];

        let panels: IcepanelSettings[] = [
          new IcepanelSettings(panelTag, panelKey, "", "", sections, headerControls)
            .enableForm()];

        let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
        setup = new IcepanelcontainerSettings("ReportViewContainer", panelrows);
      }


      let acttype = this.getReportDomainType();
      let act = this.getReportDomain();
      let api = this.getAPIBasePath(acttype);

      let loginSvc = this.getLoginService();
      if (loginSvc.whitelabel_brand != null && loginSvc.whitelabel_brand.length > 0) {
        this.whiteLabelHeader = "./assets/HQ-LetterHead.png";
      }

      this.getCodeService().getCodes("SUBTYPE_ITEM", "", "", "", "", IceTypes.ACCOUNT_TYPE.actNone).subscribe(
        data => {
          if (data != null && data.length > 0) {
            this.subTypeCodes = data;

            this.getReportService().getData(api, act, acttype, this.reportObj.report_key).subscribe(
              data => {
                if (data && data.length > 0 && data[0] != null) {
                  this.reportData = data[0];
                  this.loadReportData(this.reportObj, this.reportData, sections);
                }
                else {
                  this.reportData = new reportdata();
                  this.loadReportData(this.reportObj, this.reportData, sections);
                }
              },
              error => {
                console.log(JSON.stringify(this.getReportService().getLastErrors()));
              });
          }
        },
        error => {
        });
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  //////////////////////////////
  // Events
  public onHeaderActionClick(event) {
    if (event.headerCtrl && event.headerCtrl.id == "CancelReport") {
      // To do: Save Modified Prompt
      this.getRouter().navigate([this.getNavService().buildRoute("reports", false)]);
      return;
    }
    else if (event.headerCtrl && event.headerCtrl.id == "Sample") {
      if (this.isAntenatalData()) {
        this.ancAttendanceTable.iColumns.push(
          new iceColumnDefinition("sample1", "Sample 1", false, false,
            new IcecontrolSettings("icelabel", { linkMode: "labelanchor" }, null, null)));

        for (let i = 0; i < this.ancAttendanceData.data.length; i++) {
          let dataPoint = this.ancAttendanceData.data[i];
          if (dataPoint == null) continue;

          dataPoint["sample1"] = dataPoint["value"];
        }
      }

      if (this.isLaborandDeliveryData())  {
        this.laborDeliveryTable.iColumns.push(
          new iceColumnDefinition("sample1", "Sample 1", false, false,
            new IcecontrolSettings("icelabel", { linkMode: "labelanchor" }, null, null)));

        for (let i = 0; i < this.laborDeliveryData.data.length; i++) {
          let dataPoint = this.laborDeliveryData.data[i];
          if (dataPoint == null) continue;

          dataPoint["sample1"] = dataPoint["value"];
        }
      }

      this.patientData.data = this.getPatientData();
      this.patientTable.setShowTable(true);

      return;
    }

    if (event.headerCtrl instanceof IcepanelSettings) {
      let reportPanel: IcepanelSettings = event.headerCtrl;
      this.getRouter().navigate([this.getNavService().buildRoute("report/" + this.reportObj.report_key, false)]);
    }
  }

  public onButtonClick(event) {
    if (event.buttonSettings == null) return;

    try {
      if (event.buttonSettings.id != null && event.buttonSettings.id.indexOf("SignButton") >= 0) {
        let title = "";
        if (this.signTitle != null) {
          title = this.signTitle.getFormControl().value;
        }

        let multimediaData: IMultimediaData = this.signatureCtrl.getFormControl().value;
        let base64Obj = this.getLoginService().getBase64();
        multimediaData.value = base64Obj.encode(multimediaData.value);
        sessionStorage.setItem("multimediaData", multimediaData.value);
        let state = ";acttype:" + this.getAppService().getCurrentAccountType().toString() + ";"
          + ";act:" + this.getAppService().getCurrentAccount()
          + ";srctype:" + IceTypes.SourceType.srcStatement
          + ";srckey:" + this.reportObj.report_key
          + ";title:" + title
          + ";signaturedata:" + "multimediaData"/*multimediaData.value*/
          + ";url:" + "viewreport/" + this.reportObj.report_key
        let signUrl = this.signerSvc.GetLoginUrl('code', state);
        window.location.replace(signUrl);
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  public onAddRowButtonClick(event) {
    if (event.matTableSettings != null) {
      switch (event.matTableSettings.tag) {
        case "SignedByTable": {
          try {
            if (this.reportViewSettings.rows != null && this.reportViewSettings.rows.length > 0) {
              let contnr = this.reportViewSettings.rows[0];
              if (contnr != null && contnr.columns != null && contnr.columns.length > 0) {
                let pnl = contnr.columns[0];
                let foundSec = pnl.sections.filter(s => s.tag == "SigningSection");
                if (foundSec.length > 0) {
                  foundSec[0].setShow(true);
                }
              }
            }
          }
          catch (e) {
            console.log(e);
          }
          break;
        }
      }
    }
  }

  onMatGridRowActionClick(event) {
    if (event.actionItem == null) return;
    let entry = event["rowData"];
    if (entry == null) {
      // To do log error
      return;
    }

    if (IceTypes.recordQuickActionRemove.value == event.actionItem.value
      && entry.reviewer_key.length > 0) {
      let foundReviewer = this.signedByData.data.filter(r => r.reviewer_key != entry.reviewer_key);
      this.getReportService().removeReportSigner(this.apiToUse, this.getAppService().getCurrentAccount(), this.getAppService().getCurrentAccountType(), this.reportData, entry.reviewer_key).subscribe(
        data => {
          this.signedByData.data = foundReviewer;
        },
        error => {
          console.log(JSON.stringify(this.getReportService().getLastErrors()));
        });
    }
  }

  public onMattableColumnClick(event) {
    if (event.tableRowData == null) return;
    if (event.tableColumn == null) return;
    if (Iceutility.isdefined(event.tableRowData["key"]) == false) return;
    if (Iceutility.isdefined(event.tableRowData["value"]) == false) return;
    let results = Iceutility.toLong(event.tableRowData["value"]);
    if (results == 0) return;

    let table: string = event.tableRowData["table"];
    if (table == null || table.length == 0) return;

    let datapoint = event.tableRowData["key"];

    this.samplePanelSettings = [];
    for (let ipt = 0; ipt < this.reportData.PATIENTSTATS.length; ipt++) {
      let ptstat: patientstat = this.reportData.PATIENTSTATS[ipt];
      if (ptstat == null) continue;

      if (Iceutility.isdefined(ptstat[table]) == false) continue;
      let ptresulttable: any[] = ptstat[table];
      if (ptresulttable == null || ptresulttable.length == 0) continue;

      if (Iceutility.isdefined(ptresulttable[0]) == false || Iceutility.isdefined(ptresulttable[0][datapoint]) == false) continue;
      let ptresultdatapoint = ptresulttable[0][datapoint];
      if (Iceutility.toLong(ptresultdatapoint) == 0) continue;

      let age: number = Iceutility.convertDatesToYears(Iceutility.ConvertFromDotNetServerTime(ptstat.dob), Iceutility.GetLocalDate());
      let reportTables: IcemattableSettings[] = [];

      if (this.isAntenatalData() && ptstat.ANTENATAL_ATTENDANCE_STAT.length > 0) {
        let ancAttendanceData: MatTableDataSource<any> = new MatTableDataSource<any>([]);
        reportTables.push(this.setupAntenatal(ancAttendanceData));
        setTimeout(() => {
          let attndObj: antenatalattendancestat = ptstat.ANTENATAL_ATTENDANCE_STAT[0];
          ancAttendanceData.data = this.getAntenatalData(attndObj);
        }, 200);
      }

      if (this.isLaborandDeliveryData() && ptstat.LABOR_DELIVERY_STAT.length) {
        let laborandDeliveryData: MatTableDataSource<any> = new MatTableDataSource<any>([]);
        reportTables.push(this.setLaborandDelivery(laborandDeliveryData));
        setTimeout(() => {
          let laborObj: labordeliverystat = ptstat.LABOR_DELIVERY_STAT[0];
          laborandDeliveryData.data = this.getLaborandDeliveryData(laborObj);
        }, 500);
      }

      let sections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("ReportSection", { class: ["yalla"], styles: { width: "75%" } }, null, null, reportTables)
          .setControlAlignment(SECTION_CONTROL_ALIGNMENT.ctrlAlignVertical)
      ];

      let heading = ptstat.trans_account + " age: " + Iceutility.toLong(age).toString() + " gender: " + ptstat.sex;
      this.samplePanelSettings.push(new IceexpansionpanelSettings(event.tableColumn.columnName, event.tableRowData["key"], heading, "", sections, null, null, null)
        .enableForm());
    }

    const bottomSheetRef = this.bottomSheet.open(IcebottomSheetComponent, {
      data: { panels: this.samplePanelSettings }
    });

    bottomSheetRef.afterDismissed().subscribe(() => {
    });
  }
}
